import React from 'react';

const InfoPageBody = ({ page, variant = 'full' }) => {
  if (!page) return null;

  if (variant === 'panel') {
    return (
      <div className="info-page-body info-page-body--panel">
        <div className="info-page-panel-doc">
          <p className="info-page-panel-lead">{page.intro}</p>

          {page.sections.map((section) => (
            <div key={section.title} className="info-page-panel-block">
              <h3>{section.title}</h3>
              {section.body?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.items ? (
                <ul className="info-page-list">
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}

          {page.faqs ? (
            <div className="info-page-panel-block info-page-panel-faqs">
              <h3>Frequently Asked Questions</h3>
              {page.faqs.map((faq) => (
                <div key={faq.question} className="info-page-panel-faq-item">
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="info-page-body">
      <section className="info-page-hero">
        <p className="info-page-eyebrow">{page.eyebrow}</p>
        <h1>{page.title}</h1>
        <p className="info-page-intro">{page.intro}</p>
      </section>

      <section className="info-page-overview">
        <article className="info-page-card">
          <h2>Highlights</h2>
          <ul className="info-page-list">
            {page.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <aside className="info-page-card info-page-sidebar">
          <h2>{page.sidebarTitle}</h2>
          <ul className="info-page-list">
            {page.sidebarItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </aside>
      </section>

      <section className="info-page-sections">
        {page.sections.map((section) => (
          <article key={section.title} className="info-page-card">
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.items ? (
              <ul className="info-page-list">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </article>
        ))}
      </section>

      {page.faqs ? (
        <section className="info-page-faqs">
          {page.faqs.map((faq) => (
            <article key={faq.question} className="info-page-card">
              <h2>{faq.question}</h2>
              <p>{faq.answer}</p>
            </article>
          ))}
        </section>
      ) : null}
    </div>
  );
};

export default InfoPageBody;
